import { fetchJsonResponse } from '@/ai/api'
import { buildSingleEntityPrompt } from '@/ai/prompts'

export const generateSingleEntity = async ({
  eventId,
  workflow,
  svgGraph,
  svgLanes,
  cardTypes,
  name,
  entityDescription,
  abortController
}) => {
  if (!workflow || !workflow.aiVersion) {
    return null
  }

  const messages = buildSingleEntityPrompt({
    eventId,
    workflow,
    svgGraph,
    svgLanes,
    cardTypes,
    name,
    entityDescription
  })

  try {
    const response = await fetchJsonResponse({
      messages,
      aiVersion: workflow.aiVersion,
      signal: abortController?.signal
    })

    return response || null
  } catch (error) {
    return null
  }
}
